import security from './security.svg';
import trade from './trade.png';

interface ImageType {
	security: string,
	trade: string
}

const Images: ImageType = {
	security: security,
	trade: trade
};

export default Images;